import React from "react"

class ScenarioFormComponent extends React.Component {

	render() {
    const ids          = {
			description					: "ppi-scenario-description",
			comments						: "ppi-scenario-comments",
		}

		return (
			<form onSubmit={this.props.onSubmit}>
				{ this.props.delete
					? <div>Êtes-vous sûr de vouloir supprimer le scenario <strong>{this.props.scenario.description}</strong> ?</div>
					: this.props.duplicate
						? <div>Êtes-vous sûr de vouloir dupliquer le scénario <strong>{this.props.scenario.description}</strong> ?</div>
						: this.props.validate
							? <div>Vous êtes sur le point de {this.props.scenario.validated ? "invalider" : "valider"} le scénario <strong>{this.props.scenario.description}</strong>.</div>
							: <div className="columns is-desktop">
									<div className="column">
										<p className="field is-horizontal">
											<span className="field-label is-normal">
												<label className="label" htmlFor={ids.description}>Description</label>
											</span>
											<span className="field-body">
												<span className="field">
													<span className="control">
														<input
															className   = "input"
															id          = {ids.description}
															name        = "description"
															onChange    = {this.props.onDescriptionChange}
															placeholder = "Description"
															type        = "text"
															value       = {this.props.description}
															required />
													</span>
												</span>
											</span>
										</p>
										<p className="field is-horizontal">
											<span className="field-label is-normal">
												<label className="label" htmlFor={ids.comments}>Commentaires</label>
											</span>
											<span className="field-body">
												<span className="field">
													<span className="control">
														<textarea
															className   = "textarea"
															rows				= "5"
															id          = {ids.comments}
															name        = "comments"
															onChange    = {this.props.onCommentsChange}
															placeholder = "Commentaires"
															value       = {this.props.comments}
															required />
													</span>
												</span>
											</span>
										</p>
									</div>
								</div>
				}
				<div className="columns">
					{/* !this.props.submitting
						? <div className="column">
								<button className={`button is-secondary ${this.props.submitting ? "is-loading" : ""}`}>
									Annuler
								</button>
							</div>
						: null
					*/}
					<div className="column">
						<button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`}>
							{this.props.delete ? "Supprimer" : (this.props.duplicate ? "Dupliquer" : (this.props.validate ? (this.props.scenario.validated ? "Invalider" : "Valider") : (this.props.scenario ? "Modifier" : "Ajouter")))} le scénario
						</button>
					</div>
				</div>
			</form>
		)
	}


}

export default ScenarioFormComponent



// WEBPACK FOOTER //
// ./src/component/scenarii/common/scenario-form-component.js